// export async function openNotification (obj, opts = {}) {
//   const state = this.getRootState()

//   // Ensure notifications array exists
//   if (!state.notifications) {
//     await state.apply(s => {
//       s.notifications = []
//     }, { preventUpdate: true })
//   }

//   // Check if this is a repeated notification
//   const existingNotificationIndex = state.notifications.findIndex(
//     notification => notification.title === obj.title && notification.message === obj.message
//   )

//   // Generate a unique ID for each notification for better tracking
//   const notificationId = Date.now() + Math.random().toString(36).substring(2, 9)
//   let notification = { ...obj, id: notificationId, timestamp: Date.now() }

//   // If this is a duplicate notification, we'll update the existing one with a count
//   if (existingNotificationIndex !== -1 && !opts.forceNew) {
//     const existingNotification = state.notifications[existingNotificationIndex]
//     const count = existingNotification.count || 1

//     // Update the existing notification with an increased count
//     notification = {
//       ...existingNotification,
//       count: count + 1,
//       id: notificationId, // Give it a new ID to force UI update
//       timestamp: Date.now(),
//       message: `${obj.message.replace(/ \(\d+\)$/u, '')  } (${count + 1})`
//     }

//     // Remove the existing notification
//     await state.apply(
//       s => {
//         s.notifications.splice(existingNotificationIndex, 1)
//       },
//       { preventUpdate: true }
//     )
//   }

//   // Add the notification to the array
//   await state.apply(
//     s => {
//       s.notifications.push(notification)
//     },
//     { preventUpdate: true }
//   )

//   const NotifElement = this.getRoot('GlobalNotification')
//   if (!NotifElement) {
//     console.error('GlobalNotification component not found')
//     return
//   }

//   NotifElement.update()

//   const notifs = this.getRootState('notifications') || []
//   const current = NotifElement.content[notifs.length - 1]
//   if (!current) {
//     return
//   }

//   // Auto-close the notification after a delay
//   setTimeout(() => {
//     if (!current || current?.props.animation === 'fadeOutDown') {
//       return
//     }
//     current.call('closeNotification')
//   }, notification.duration || obj.duration || opts.duration || 5000)
// }

export async function openNotification(obj, opts = {}) {
  const state = this.getRootState()

  // Check for existing notification with same title
  if (
    state.notifications?.some(
      (notification) => notification.title === obj.title
    )
  ) {
    return
  }

  await state.apply(
    (s) => {
      s.notifications.push({ ...obj, id: s.notifications.length })
    },
    { preventUpdate: true }
  )

  const NotifElement = this.getRoot('GlobalNotification')
  await NotifElement.update()

  const notifs = this.getRootState('notifications')
  const current = NotifElement.content[notifs.length - 1]
  if (!current) {
    return
  }

  const t = setTimeout(
    () => {
      // console.log('remove', current)
      // if (current?.props.animation === 'fadeOutDown') {
      //   return
      // }
      current.call('closeNotification', current)
      clearTimeout(t)
    },
    obj.duration || opts.duration || 3500
  )
}

export async function openNotificationParams(title, error, message, opts = {}) {
  return await openNotification.call(this, { title, error, message }, opts)
}

export function closeNotification(current, opts = {}) {
  if (!opts.forced && this.state.hover) {
    const t = setTimeout(() => {
      this.call('closeNotification', current, opts)
      clearTimeout(t)
    }, opts.retryTimeout || 500)
    return
  }

  const NotifElement = this.getRoot('GlobalNotification')
  if (!NotifElement || !NotifElement.content) {
    return
  }

  const notifs = this.getRootState('notifications') || []
  if (!current) {
    let key = parseInt(this.key, 10) || 0
    while (!notifs[key] && key > -1) {
      key = parseInt(key, 10) - 1
    }

    if (notifs.length > 0) {
      notifs.splice(key, 1)
    }

    current = NotifElement.content[key] || (this.state.title && this)
  }

  if (!current) {
    return
  }

  // // Use notification ID if available for more precise removal
  // const index = this.state.id
  //   ? notifs.findIndex(notification => notification.id === this.state.id)
  //   : notifs.findIndex(notification => notification.title === this.state.title)

  // if (index > -1) {
  //   notifs.splice(index, 1)
  // }

  current.update({
    animation: 'fadeOutDown',
    height: '0',
    paddingBlock: '0'
  })

  const t = setTimeout(() => {
    current.remove()
    clearTimeout(t)
  }, opts.duration || 500)
}
